let ticking = false

export function setNavBarActiveLink () {
  const navLinksContainer = document.getElementById('header-nav-links')
  const navLinks = navLinksContainer.getElementsByClassName('nav-link')

  for (const navLink of navLinks) {
    if (navLink.href === `${window.location.origin}${window.location.pathname}`) navLink.classList.add('active')
    else navLink.classList.remove('active')
  }
}

document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      const header = document.getElementById('header')

      if (window.scrollY > 0) {
        if (!header.classList.contains('active')) {
          header.classList.add('active')
        }
      } else {
        header.classList.remove('active')
      }

      ticking = false
    })

    ticking = true
  }
})
